var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell",class:[
       _vm.cell.prop,
       _vm.cell.propType,
     ],on:{"click":function($event){return _vm.openCarPopup()}}},[_c('div',{staticClass:"app-table__cell-content car-number-cell"},[_c('div',{staticClass:"car-number-cell__main"},[_vm._v(_vm._s(_vm.value))]),(_vm.entity.camCarNumber && _vm.entity.camCarNumber !== _vm.value)?_c('div',{staticClass:"car-number-cell__cam-number",attrs:{"title":"Номер, который зафиксировала камера"}},[_vm._v(" ("+_vm._s(_vm.entity.camCarNumber)+") ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }